import { z } from 'zod';
import { zDate } from '../core';
import { BlockStatus, BlockType as BlockTypeEnum, } from '@strength/db-schema';
// Re-exporting so the client has access
export { zBlockType };
const zBlockLayout = z.record(z.number().or(z.string()), z.number());
const zBlockType = z.enum(BlockTypeEnum.enumValues);
export var BlockDomain;
(function (BlockDomain) {
    BlockDomain.Module = 'Block';
    const module = z.literal(BlockDomain.Module);
    BlockDomain.Create = z.object({
        module,
        type: z.literal('Create'),
        input: z.object({
            id: z.uuid(),
            name: z.string(),
            blockType: zBlockType,
            focuses: z.array(z.object({
                id: z.uuid(),
                focusId: z.uuid(),
                sortOrder: z.number(),
            })),
            startDate: zDate,
            endDate: zDate,
            trackId: z.uuid(),
            trainingMaxRatio: z.number().positive().max(1),
            cycleLabel: z.string(),
            sessionLabel: z.string(),
            layout: zBlockLayout,
            autoSchedule: z.boolean(),
            allowFlexWorkouts: z.boolean().default(false),
        }),
    });
    BlockDomain.Copy = z.object({
        module,
        type: z.literal('Copy'),
        input: z.object({
            id: z.uuid(),
            blockIdToCopy: z.uuid(),
            name: z.string(),
            focuses: z.array(z.object({
                id: z.uuid(),
                focusId: z.uuid(),
                sortOrder: z.number(),
            })),
            blockType: zBlockType,
            startDate: zDate,
            endDate: zDate,
            trackId: z.uuid(),
            trainingMaxRatio: z.number().positive().max(1),
            cycleLabel: z.string(),
            sessionLabel: z.string(),
            layout: zBlockLayout,
            autoSchedule: z.boolean(),
            allowFlexWorkouts: z.boolean().default(false),
        }),
    });
    BlockDomain.Edit = z.object({
        module,
        type: z.literal('Edit'),
        input: z.object({
            id: z.uuid(),
            name: z.string(),
            focuses: z.array(z.object({
                id: z.uuid(),
                focusId: z.uuid(),
                sortOrder: z.number(),
            })),
            startDate: zDate,
            endDate: zDate,
            trainingMaxRatio: z.number().positive().max(1),
            layout: zBlockLayout,
            autoSchedule: z.boolean(),
            allowFlexWorkouts: z.boolean().default(false),
            status: z.enum(BlockStatus.enumValues).optional(),
        }),
    });
    BlockDomain.Delete = z.object({
        module,
        type: z.literal('Delete'),
        input: z.object({
            id: z.uuid(),
        }),
    });
    BlockDomain.Cancel = z.object({
        module,
        type: z.literal('Cancel'),
        input: z.object({
            id: z.uuid(),
        }),
    });
    BlockDomain.DEFAULT_CYCLE_LENGTH_IN_DAYS = 7;
})(BlockDomain || (BlockDomain = {}));
//# sourceMappingURL=domain.js.map